"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = require("../Base");
var Tealium_1 = require("../Tealium");
var HeartBeat = /** @class */ (function (_super) {
    __extends(HeartBeat, _super);
    function HeartBeat() {
        var _this = _super.call(this) || this;
        _this.eventCategory = 'player';
        _this.initialHeartBeat = false;
        _this.timer = null;
        _this.timers = {};
        _this.intervals = {};
        _this.counter = -1;
        _this.currentInterval = 0;
        _this.currentHeartBeat = 0;
        _this.scheme = [
            {
                start: 10,
                interval: 10,
            },
            {
                start: 60,
                interval: 60,
            },
        ];
        _this.options = {};
        _this.init = function (options) {
            if (options === void 0) { options = {}; }
            _this.eventCategory = options.eventCategory || _this.eventCategory;
            _this.initialHeartBeat = _this.options.initialHeartBeat || _this.initialHeartBeat;
            _this.setScheme(options.scheme || _this.scheme);
            if (options.events) {
                _this.events = options.events;
            }
        };
        _this.setScheme = function (scheme) {
            _this.scheme = scheme;
            _this.scheme.sort(function (a, b) { return a.start - b.start; });
        };
        _this.setupCounter = function () {
            _this.counter = 0;
            _this.timer = setInterval(function () {
                _this.counter = _this.counter + 1;
            }, HeartBeat.toMs(1));
        };
        _this.setupTimers = function () {
            _this.scheme.forEach(function (scheme, index) {
                _this.timers[index] = setTimeout(function () {
                    if (index === 0 && _this.initialHeartBeat) {
                        // Send the initial heart beat of the scheme
                        _this.emitHeartBeat();
                    }
                    else if (index > 0) {
                        // Send the last one of the previous scheme
                        _this.emitHeartBeat();
                        _this.clearInterval(index - 1);
                    }
                    if (index > 0) {
                        // clear the previous interval
                        _this.clearInterval(index - 1);
                    }
                    _this.info("".concat(HeartBeat.getCurrentTime(), " - HeartBeat: start scheme ").concat(index + 1, " with interval of ").concat(scheme.interval, " seconds"));
                    _this.currentInterval = scheme.interval;
                    // Set the new interval
                    _this.intervals[index] = setInterval(function () {
                        _this.emitHeartBeat();
                    }, HeartBeat.toMs(scheme.interval));
                }, HeartBeat.toMs(scheme.start));
            });
        };
        _this.clearTimeout = function (index) { return clearTimeout(_this.timers[index]); };
        _this.clearInterval = function (index) { return clearInterval(_this.intervals[index]); };
        _this.start = function () {
            if (_this.counter !== -1) {
                _this.stop();
            }
            _this.info("".concat(HeartBeat.getCurrentTime(), " - HeartBeat: start HeartBeat"));
            _this.setupCounter();
            _this.setupTimers();
        };
        _this.stop = function () {
            if (_this.timer) {
                clearInterval(_this.timer);
            }
            _this.info("".concat(HeartBeat.getCurrentTime(), " - HeartBeat: stop HeartBeat"));
            _this.scheme.forEach(function (_scheme, index) {
                clearTimeout(_this.timers[index]);
                clearInterval(_this.intervals[index]);
            });
            _this.counter = -1;
            _this.currentHeartBeat = 0;
            _this.currentInterval = 0;
        };
        _this.emitHeartBeat = function () {
            _this.currentHeartBeat += _this.currentInterval;
            _this.sendHeartBeat({
                currentHeartBeat: _this.currentHeartBeat,
                currentInterval: _this.currentInterval,
            });
        };
        _this.sendHeartBeat = function (data) {
            var _a, _b;
            _this.info("".concat(HeartBeat.getCurrentTime(), " - HeartBeat: emit ").concat(data.currentHeartBeat));
            // Collect all the necessary data for the track event
            var collectCallbackData = ((_a = _this.events) === null || _a === void 0 ? void 0 : _a.onHeartBeat) ? (_b = _this.events) === null || _b === void 0 ? void 0 : _b.onHeartBeat(data) : {};
            var fireTrack = typeof collectCallbackData === 'boolean' ? collectCallbackData : true;
            if (!fireTrack) {
                // Don't sent event
                return;
            }
            var action = 'heartbeat';
            Tealium_1.default.link(__assign({ event_category: _this.eventCategory, event_name: "player_".concat(action), event_label: data.currentHeartBeat, event_value: data.currentInterval }, collectCallbackData));
        };
        _this.name = 'HeartBeat';
        return _this;
    }
    Object.defineProperty(HeartBeat.prototype, "state", {
        get: function () {
            return this.counter === -1 ? 'idle' : 'running';
        },
        enumerable: false,
        configurable: true
    });
    HeartBeat.getCurrentTime = function () {
        var date = new Date();
        var hours = "0".concat(date.getHours()).slice(-2);
        var minutes = "0".concat(date.getMinutes()).slice(-2);
        var seconds = "0".concat(date.getSeconds()).slice(-2);
        return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
    };
    HeartBeat.toMs = function (sec) { return sec * 1000; };
    return HeartBeat;
}(Base_1.default));
exports.default = new HeartBeat();
